'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@src/utils/tailwind';
interface PillProps {
  label: string;
  isActive: boolean;
}
export function Pill(t0) {
  const $ = _c(5);
  const {
    label,
    isActive
  } = t0;
  const t1 = isActive && "border-transparent bg-bodi-black font-semibold text-bodi-accent-bright-500 hover:bg-bodi-black";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("box-border block rounded-[40px] border border-bodi-gray-light bg-bodi-white px-4 py-3 font-medium hover:bg-bodi-gray-pearl lg:px-6", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== label || $[3] !== t2) {
    t3 = <button className={t2}>{label}</button>;
    $[2] = label;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}